import { cn, isMobileAtom, useRecoil } from '@orcar/common-d2c';
import { useState } from 'react';
import {
  PET_FAQ_LIST,
  PET_GUIDE_BANNER,
  PET_GUIDE_CONTACTS,
} from '@/constants/cs-center';
import PetPreparationSheet from '@/pages/reservation/payment/components/PetPreparationSheet';
import FaqCard from './FaqCard';

/**
 * 고객센터 "반려동물 동반" 탭 콘텐츠.
 * - 상단 배너: "필수 준비사항 보기" → 결제 페이지와 동일한 준비사항 시트 재사용
 * - 반려동물 동반 자주 묻는 질문(아코디언)
 * - 연락처 카드
 */
const PetGuideSection = () => {
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);
  const [sheetOpen, setSheetOpen] = useState(false);

  return (
    <div className='flex w-full flex-col gap-7'>
      {/* 안내 배너 */}
      <div
        className={cn(
          'flex gap-4 rounded-[16px] bg-gradient-to-r from-primary-050 to-[#3AC5B8] px-7 py-6 text-grey-000',
          isMobile ? 'flex-col items-start' : 'items-center justify-between',
        )}
      >
        <div className='flex items-center gap-4'>
          <span className='text-[40px] leading-none'>🐶</span>
          <div className='flex flex-col gap-1'>
            <span className='caption1 opacity-90'>{PET_GUIDE_BANNER.label}</span>
            <span className='sub1 font-bold'>{PET_GUIDE_BANNER.title}</span>
            <span className='body2 opacity-90'>
              {PET_GUIDE_BANNER.description}
            </span>
          </div>
        </div>
        <button
          type='button'
          onClick={() => setSheetOpen(true)}
          className={cn(
            'sub3 shrink-0 rounded-s bg-grey-000 px-5 py-3 font-bold text-primary-050',
            isMobile && 'w-full',
          )}
        >
          {PET_GUIDE_BANNER.buttonLabel}
        </button>
      </div>

      {/* 자주 묻는 질문 */}
      <div className='flex flex-col gap-3'>
        <p className='sub2 font-bold text-grey-090'>
          🐾 반려동물 동반 자주 묻는 질문
        </p>
        <div className='flex flex-col'>
          {PET_FAQ_LIST.map((faq) => (
            <FaqCard key={faq.query} query={faq.query} answer={faq.answer} />
          ))}
        </div>
      </div>

      {/* 연락처 */}
      <div
        className={cn(
          'grid gap-3',
          isMobile ? 'grid-cols-1' : 'grid-cols-3',
        )}
      >
        {PET_GUIDE_CONTACTS.map((contact) => (
          <div
            key={contact.label}
            className='flex flex-col gap-1 rounded-s border border-grey-020 px-5 py-4'
          >
            <p className='caption1 text-grey-060'>{contact.label}</p>
            <p className='sub3 font-bold text-grey-090'>{contact.value}</p>
          </div>
        ))}
      </div>

      <PetPreparationSheet
        open={sheetOpen}
        onClose={() => setSheetOpen(false)}
        onConfirm={() => setSheetOpen(false)}
        isMobile={isMobile}
      />
    </div>
  );
};

export default PetGuideSection;
